import { produce } from "immer";
import {
  ENHANCE_COMMENT,
  ENHANCE_COMMENT_FAILURE,
  ENHANCE_COMMENT_SUCCESS,
  ENHANCE_FEED,
  ENHANCE_FEED_SUCCESS,
  ENHANCE_FEED_FAILURE,
  KUDOS_AI_SUGGEST,
  KUDOS_AI_SUGGEST_SUCCESS,
  KUDOS_AI_SUGGEST_FAILURE,
} from "./constants";

export const initialState = {
  isEnhancingComment: false,
  isEnhancingFeed: false,
  isKudosAiSuggesting: false,
};

const AISliceReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ENHANCE_COMMENT:
        draft.isEnhancingComment = true;
        break;
      case ENHANCE_COMMENT_SUCCESS:
        draft.isEnhancingComment = false;
        break;
      case ENHANCE_COMMENT_FAILURE:
        draft.isEnhancingComment = false;
        break;

      case ENHANCE_FEED:
        draft.isEnhancingFeed = true;
        break;
      case ENHANCE_FEED_SUCCESS:
        draft.isEnhancingFeed = false;
        break;
      case ENHANCE_FEED_FAILURE:
        draft.isEnhancingFeed = false;
        break;

      case KUDOS_AI_SUGGEST:
        draft.isKudosAiSuggesting = true;
        break;
      case KUDOS_AI_SUGGEST_SUCCESS:
        draft.isKudosAiSuggesting = false;
        break;
      case KUDOS_AI_SUGGEST_FAILURE:
        draft.isKudosAiSuggesting = false;
        break;

      default:
        return state;
    }
  });

export default AISliceReducer;
